export const SIZE_NAME = {
    sqMeter: 'ตารางเมตร',
    rai_ngan_sqWa: 'ไร่งานวา',
    sqKiloMeter: 'ตารางกิโลเมตร',
    sqFoot: 'ตารางฟุต',
    sqYards: 'ตารางหลา',
    sqMiles: 'ตารางไมล์',
    hectare: 'เฮกตาร์',
    acre: 'เอเคอร์',
}